<!-- Icon -->
<div class="xl:hidden logo flex jsutify-start items-center relative w-full max-xl:mb-4">
  <a routerLink="/" class="btn-filled grad-ltd" (click)="closeMenu()">
    <img width="164px" height="28px" src="./assets/images/logo.svg" />
  </a>

  <a class="flex xl:hidden items-center justify-center rounded-lg absolute right-[2px] top-[6px]" (click)="closeMenu()">
    <svg-icon key="xIcon" fontSize="18px" class="text-gray-900 hover:text-primary-500"></svg-icon>
  </a>
</div>

<!-- Search -->
<div class="search flex items-center w-full md:max-w-[308px]">
  <!-- [case]="{key: 'in-header', props: { showSearch }}"  // props này chỉ dùng trong key của 'in-header'. Các key khác không dùng. -->
  <franbase-search-main class="flex w-full items-center max-h-[50px]" [case]="{key: 'in-header', props: { showSearch }}" inputClass="max-xl:!h-[3.6875rem]" (updateShowSearch)="handleUpdateShowSearch($event)"></franbase-search-main>
</div>

<ng-container *ngIf="menus$ | async; let menus">
<!-- Menu -->
<ul nz-menu nzMode="inline" nzTrigger="click" class="menu-inner xl:hidden max-xl:max-h-[calc(100vh-120px)] max-xl:overflow-y-auto max-xl:overflow-x-hidden">
  <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menus }"></ng-container>
  <ng-template #menuTpl let-menus>
    <ng-container *ngFor="let menu of menus">
      <li
        *ngIf="!menu.children"
        nz-menu-item
        [nzPaddingLeft]="menu.level === 3 ? 24 : 0"
        [nzDisabled]="menu.disabled"
        [nzSelected]="menu.selected"
      >
        <h6 *ngIf="menu.level===1 || menu.level===2" class="capitalize">
          {{menu.title}}
          <svg-icon *ngIf="menu.children" key="arrowDownGrayIcon" fontSize="10px" class="ml-1 text-gray-600"></svg-icon>
        </h6>
        <p *ngIf="menu.level===3" class="capitalize flex items-center">
          <a (click)="closeMenu()" *ngIf="menu.link" [routerLink]="menu.link" class="full-width-menu-link">
            {{menu.title}}<svg-icon *ngIf="menu.fire" key="fireIcon" class="text-red-fire ml-1" nz-popover fontSize="24px"></svg-icon>
          </a>
        </p>
      </li>
      <li
        *ngIf="menu.children"
        nz-submenu
        [nzOpen]="menu.open"
        [nzTitle]="(menu.level === 2 || menu.level === 1) ? templateTitleMobile : templateTitleMobile2"
        [nzDisabled]="menu.disabled"
        class="[&_.ant-menu-sub]:bg-white {{'ant-menu-submenu-lv' + menu.level }} [&_.ant-menu-submenu-title]:!py-[1.75rem] [&_.ant-menu-submenu-title]:!my-0 {{menu.level>1?'rounded-lg hover:bg-[#eeeeee]':''}}"
      >
        <ul class="{{menu.level === 1 ? 'border-t border-t-1 border-[#eeeeee] !py-4' : ''}}">
          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }"></ng-container>
        </ul>
      </li>
      <ng-template #templateTitleMobile>
        <h6 class="capitalize">
          <span class="flex items-center justify-start">
            <svg-icon *ngIf="menu.icon" [key]="menu.icon" fontSize="18px" class="mr-4 text-primary-500"></svg-icon>
            {{menu.title}}
          </span>
        </h6>
      </ng-template>
      <ng-template #templateTitleMobile2>
        <p class="capitalize">
          {{menu.title}}
        </p>
      </ng-template>
    </ng-container>
  </ng-template>
</ul>

<!-- desktop -->
<div class="flex items-center jusfify-between ml-auto gap-x-6 max-xl:hidden">
  <ng-container *ngFor="let item of menus">
    <a *ngIf="item.link" [routerLink]="item.link" class="full-width-menu-link">
      <div class="h6 capitalize">{{item.title}}
      </div>
    </a>
    <franbase-link-dropdown-item
      *ngIf="!item.link&&item.children&&item.children.length"
      [item]="item"
      [isShowDropdown]="showDropdownCate"
      (setDropdown)="handleSetDropdown($event)"
    ></franbase-link-dropdown-item>
  </ng-container>
</div>

</ng-container>

<div   class="xl:ml-10 signin-block flex max-xl:items-center max-xl:flex-col max-xl:w-full max-xl:[&_.ant-btn]:w-full max-xl:[&_.ant-btn]:m-0 max-xl:[&_.ant-btn]:m-0 max-xl:space-y-4">
  <ng-container *ngIf="auth_profile$ | async as auth_profile; else notSignedIn">
    <div nz-dropdown nzTrigger="click" [nzDropdownMenu]="avatar" class="flex items-center justify-between cursor-pointer">
      <a class="mr-4 rounded-full overflow-hidden">
        <img class="h-[40px] w-[40px]" src="./assets/images/no-image.png" />
      </a>
      <h6 class="text-subtitle">{{auth_profile.first_name}} {{auth_profile.last_name}}</h6>
    </div>
    <nz-dropdown-menu #avatar="nzDropdownMenu">
      <ul nz-menu nzPlacement="bottomLeft" nzTitle="bottomLeft" class="rounded-lg [&>li]:text-sm [&>li]:py-2">
        <li nz-menu-item routerLink="/user/profile">Profile</li>
        <li nz-menu-item (click)="logout()">Logout</li>
      </ul>
    </nz-dropdown-menu>
  </ng-container>
  <ng-template #notSignedIn>
    <a routerLink="/signup" nz-button nzType="link" class="btn-filled uppercase max-xl:h-[3.5rem] text-sm">Register</a>
    <franbase-gradient-btn type="link" link="login" btnClass="max-xl:h-[3.5rem] text-sm" class="uppercase xl:ml-3 w-full">Login</franbase-gradient-btn>
  </ng-template>
</div>
